module.exports = __webpack_public_path__ + "img/112.353a9afe.jpg";